<template lang="pug">
  div
    balance-modal(
      ref="balanceModal"
      title="Изменить баланс пользователя?"
      :email="targetEmail"
      :firmId="targetId"
      v-on:confirm="changeBalanceConfirm"
    )
    tariff-modal(
      ref="tariffModal"
      :email="targetEmail"
      :firmId="targetId"
    )
    vue-good-table(
      v-if="users"
      ref="table"
      :columns="columns"
      :rows="users"
      :sort-options=`{
        enabled: true,
        initialSortBy: {field: 'created_at', type: 'desc'}
      }`
      :pagination-options=`{
        enabled: true,
        perPage: 20,
        nextLabel: $t('pagination.next'),
        prevLabel: $t('pagination.back'),
        rowsPerPageLabel: $t('pagination.output'),
        allLabel: $t('pagination.all'),
        ofLabel: $t('pagination.of'),
      }`
    )
      template(slot="table-row" slot-scope="props")
        span(v-if="props.column.field == 'status'")
          | {{ props.formattedRow[props.column.field] | formatStatus }}
        span(v-else-if="props.column.field == 'tariffTitle'")
          template(v-if="parseInt(props.row.tariffCost) !== 0")
            | {{ props.row.tariffTitle }} {{ props.row.tariffCost }}
          template(v-else)
            | {{ props.row.tariffTitle }}
        span(v-else-if="props.column.field == 'utmSource'")
          template(v-if="props.row.utmSource !== null")
            strong {{ props.row.utmSource }}
            br
            small Term: {{ props.row.utmTerm }}
            br
            small Medium: {{ props.row.utmMedium }}
            br
            small Content: {{ props.row.utmContent }}
            br
            small utmCampaign: {{ props.row.utmCampaign }}
        span(v-else-if="props.column.field == 'options'").btn-icon__wrapper.vgt-table__options-cell
          button.btn.btn-icon(
            title="Изменить баланс"
            @click="e=>changeBalance(props.row.email, props.row.id)"
          )
            font-awesome-icon.sidebar__menu-icon(icon="ruble-sign")
          button.btn.btn-icon(
            title="Активировать пробный тариф"
            @click="e=>changeTariff(props.row.email, props.row.id)"
          )
            font-awesome-icon.sidebar__menu-icon(icon="gift")
          a.btn.btn-icon(
            :href="constructorUrl(props.row.iframe_token)"
            target="_blank"
            rel="noopener noreferrer"
          )
            font-awesome-icon.sidebar__menu-icon(icon="link")

</template>

<script>
import _ from 'lodash';
import apiClient from '@/apiClient';
import { mapState } from 'vuex';

import { VueGoodTable } from 'vue-good-table';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faRubleSign } from '@fortawesome/free-solid-svg-icons';
import { faGift } from '@fortawesome/free-solid-svg-icons';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { dateToLocal } from '@/modules/dates';
import config from '@/config';
import table from '@/mixins/table.mixin';

import BalanceModal from "@/components/admin/UsersTable/BalanceModal.vue";
import TariffModal from "@/components/admin/UsersTable/TariffModal.vue";

library.add(faRubleSign);
library.add(faGift);
library.add(faLink);

export default {
  mixins: [table],

  data() {
    return {
      utmFilters: [],
      columns: [
        {
          label: 'Имя',
          field: 'userName',
          filterOptions: {
            enabled: true,
            placeholder: 'Искать по имени'
          }
        },
        {
          label: 'Email',
          field: 'email',
          filterOptions: {
            enabled: true,
            placeholder: 'Искать по email'
          }
        },
        {
          label: 'Статус',
          field: 'status',
          filterOptions: {
            enabled: true,
            placeholder: 'Статус',
            filterDropdownItems: [
              { value: 'NOT_ACTIVATED', text: 'Аккаунт не активирован' },
              { value: 'ACTIVE', text: 'Аккаунт активирован' }
            ]
          }
        },
        {
          label: 'Тариф',
          field: 'tariffTitle'
        },
        {
          label: 'Тариф до',
          field: 'tariffExpiresAt',
          type: 'date',
          dateInputFormat: config.dateTimeInputFormat,
          dateOutputFormat: config.dateTimeOutputFormat,
        },
        {
          label: 'UTM',
          field: 'utmSource',
          filterOptions: {
            enabled: true,
            placeholder: 'Источник',
            filterDropdownItems: this.utmFilters
          }
        },
        {
          label: 'Фирма',
          field: 'firmName',
          filterOptions: {
            enabled: true,
            placeholder: 'Искать по названию'
          }
        },
        {
          label: 'Дата регистрации',
          field: 'created_at',
          type: 'date',
          dateInputFormat: config.dateTimeInputFormat,
          dateOutputFormat: config.dateOutputFormat,
          filterOptions: {
            enabled: true,
            placeholder: 'Дата регистрации',
            filterFn: this.dateRangeFilter
          }
        },
        {
          label: 'Баланс',
          field: 'balance',
          filterOptions: {
            enabled: true,
            placeholder: 'Искать по балансу'
          }
        },
        {
          label: 'Опции',
          field: 'options',
          thClass: 'vgt-table__cell--min-width',
          sortable: false
        }
      ],
      users: null,
      targetEmail: '',
      targetId: -1
    };
  },

  methods: {
    uniqueUtmFilters(list) {
      const uniqueUtms = _.uniqBy(list, 'utmSource');
      uniqueUtms.forEach(item => {
        if (item.utmSource !== null) {
          this.utmFilters.push(item.utmSource);
        }
      });
      this.columns.forEach(column => {
        if (column.field === 'utmSource') {
          column.filterOptions.filterDropdownItems = this.utmFilters;
        }
      });
    },
    changeBalance(email, id) {
      this.targetEmail = email;
      this.targetId = id;
      this.$refs.balanceModal.open();
    },
    changeBalanceConfirm(firmId, action, value) {
      for (let i = 0; i < this.users.length; i++) {
        if (this.users[i].id === firmId) {
          if (action === '+') {
            this.users[i].balance =
              Number.parseFloat(this.users[i].balance) +
              Number.parseFloat(value);
          } else if (action === '-') {
            this.users[i].balance =
              Number.parseFloat(this.users[i].balance) -
              Number.parseFloat(value);
          } else {
            this.users[i].balance = value;
          }
          break;
        }
      }
    },
    changeTariff(email, id) {
      this.targetEmail = email;
      this.targetId = id;
      this.$refs.tariffModal.open();
    },
    constructorUrl(token) {
      return config.urls.app(token);
    }
  },

  mounted() {
    new Promise((resolve, reject) => {
      apiClient
        .get(`/users`)
        .then(resp => {
          const users = resp.data;
          // Dates to local timezone
          users.forEach(item => {
            const dateFields = (({ created_at, tariffExpiresAt }) => ({
              created_at,
              tariffExpiresAt
            }))(item);
            for (const [key, value] of Object.entries(dateFields)) {
              item[key] = dateToLocal(
                value,
                config.dateTimeInputFormat,
                config.dateTimeInputFormat
              );
            }
          });
          this.uniqueUtmFilters(users);
          this.users = users;
          resolve(resp);
        })
        .catch(err => {
          this.flashError('Невозможно получить список пользователей.');
          reject(err);
        });
    });
  },

  filters: {
    formatStatus(status) {
      switch (status) {
        case 'ACTIVE':
          return 'Активен';
          break;
        case 'NOT_ACTIVATED':
          return 'Не активирован';
          break;
        default:
          return 'Неизвестен';
          break;
      }
    }
  },

  components: {
    VueGoodTable,
    FontAwesomeIcon,
    BalanceModal,
    TariffModal
  }
};
</script>
